/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @author Jiri Moc <jiri.moc@outlook.cz>
 * @license See LICENSE file distributed with this source code.
 */

import { Form } from "../shared/FormModel/FormModel";
import { SectionGroup } from "../shared/FormModel/elements/FormSectionGroup";
import { Section } from "../shared/FormModel/elements/FormSection";
import { Row } from "../shared/FormModel/elements/FormRow";
import { FieldText, FormFieldText } from "../shared/FormModel/elements/FormFieldText";
import { FieldSelect } from "../shared/FormModel/elements/FormFieldSelect";
import { FieldLabel } from "../shared/FormModel/elements/FormFieldLabel";
import { RowList, FormRowList } from "../shared/FormModel/elements/FormRowList";
import { HTMLContent } from "../shared/FormModel/elements/FormHTMLContent";
import { parseNumber, formatNumber, printNumberFormatter } from "../shared/formatting";
import { HiddenExpression, FormHiddenExpression } from "../shared/FormModel/elements/FormHiddenExpression";

export const form_interniKalkulace = Form({
    id: "interni-kalkulace",
    version: "2020-07-r1",
    title: "Interní kalkulace",
    icon: "google-spreadsheet",
    showInMenu: true
}, [
    SectionGroup({}, [
        Section({
            id: "detail-zakazky",
            title: "Detail zakázky"
        }, [
            Row({}, [
                FieldText({
                    width: "1/2",
                    id: "nazev-zakazky",
                    label: "Název zakázky",
                    placeholder: "Jan Novák - třešňová kuchyň"
                }),
                FieldText({
                    width: "1/2",
                    id: "vytvoreno-dne",
                    label: "Vytvořeno dne",
                    placeholder: "1.1.2020"
                })
            ])
        ]),
    ]),
    SectionGroup({
        spaceBefore: true
    }, [
        Section({
            id: "list-skrinek",
            title: "Položky nabídky"
        }, [
            RowList({}, [
                FieldText({
                    id: "nazev",
                    label: "Položka + popis",
                    placeholder: "---"
                }),
                FieldSelect({
                    width: "1/8",
                    id: "sazba-dph",
                    label: "Sazba DPH",
                    options: [{
                        value: "21",
                        label: "21%"
                    }, {
                        value: "15",
                        label: "15%"
                    }]
                }),
                FieldText({
                    width: "1/6",
                    id: "cena",
                    tag: "polozka-cena",
                    label: "Cena vč. DPH",
                    placeholder: "---",
                    pattern: /^[0-9 ]+((,|\.)[0-9]+)?$/,
                    align: "right",
                    labelAlign: "right",
                    suffix: "Kč",
                    printFormatter: printNumberFormatter(2)
                })
            ]),
            Row({
                colorSchema: "heading"
            }, [
                FieldLabel({
                    label: "Celková cena za položky vč. DPH",
                    style: "summary"
                }),
                HiddenExpression({
                    tag: "polozky-celkem",
                    value: (model) => {
                        let total = 0;
                        const list = model.getElementByTag<FormFieldText>("polozka-cena");

                        for (let i = 0; i < list.length; i++) {
                            total += parseNumber(list[i].getState().value, 0);
                        }

                        return total;
                    }
                }),
                FieldLabel({
                    width: "1/6",
                    value: (model) => {
                        const total = model.getElementByTag<FormHiddenExpression>("polozky-celkem")[0].getState().value;
                        return formatNumber(total, 2);
                    },
                    suffix: "Kč",
                    align: "right",
                    style: "summary"
                })
            ]),
            Row({
                print: false
            }, [
                FieldText({
                    id: "rabat",
                    tag: "rabat",
                    label: "Rabat",
                    value: "Obchodní přirážka"
                }),
                FieldText({
                    width: "1/6",
                    id: "sleva",
                    tag: "polozky-sleva",
                    label: "Rabat",
                    pattern: /^[0-9 ]+((,|\.)[0-9]+)?$/,
                    align: "right",
                    labelAlign: "right",
                    suffix: "%",
                    value: "0"
                }),
                FieldLabel({
                    width: "1/6",
                    label: "Výše rabatu",
                    value: (model) => {
                        const total = model.getElementByTag<FormHiddenExpression>("polozky-celkem")[0].getState().value;
                        const discount = parseNumber(model.getElementByTag<FormHiddenExpression>("polozky-sleva")[0].getState().value);

                        const discountAmount = (total * (discount / 100));

                        return formatNumber(discountAmount, 2);
                    },
                    align: "right",
                    labelAlign: "right",
                    suffix: "Kč"
                }),
                HiddenExpression({
                    tag: "polozky-celkem-po-sleve",
                    value: (model) => {
                        const total = model.getElementByTag<FormHiddenExpression>("polozky-celkem")[0].getState().value;
                        const discount = parseNumber(model.getElementByTag<FormHiddenExpression>("polozky-sleva")[0].getState().value);

                        const afterDiscount = total * (1 + (discount / 100));

                        return afterDiscount;
                    }
                }),
            ])
        ]),
    ]),
    SectionGroup({
        spaceBefore: true
    }, [
        Section({},
            [
                Row({
                    colorSchema: "heading",
                    display: (model) => {
                        return true;
                    }
                }, [
                    FieldLabel({
                        label: "Celková cena vč. DPH",
                        style: "summary"
                    }),
                    FieldLabel({
                        width: "1/6",
                        align: "right",
                        value: (model) => {
                            const total1 = model.getElementByTag<FormHiddenExpression>("polozky-celkem-po-sleve")[0].getState().value;

                            const sum = total1;

                            return formatNumber(sum, 2);
                        },
                        style: "summary",
                        suffix: "Kč"
                    })
                ])
            ])
    ])
]);